export default "__VITE_ASSET__BG0z7nVw__"